module.exports = {"340604001":"杨庄街道","340604002":"临海童街道","340604003":"百善街道","340604004":"任楼街道","340604100":"烈山镇","340604101":"宋町镇","340604102":"古饶镇","340604400":"烈山区工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340604.json
// module id = 1081
// module chunks = 0